import { Modal, ModalProps, withModalConditionalRender } from '@billy/design-system'
import { ReactElement } from 'react'

import { CreateDepositInvoiceEntryPointModalBody } from './elements/CreateDepositInvoiceEntryPointModalBody'
import { CreateDepositInvoiceEntryPointModalFooter } from './elements/CreateDepositInvoiceEntryPointModalFooter'

const CreateDepositInvoiceEntryPointModalComponent = ({ ...modalProps }: ModalProps): ReactElement => {
  return (
    <Modal {...modalProps} size="s">
      <CreateDepositInvoiceEntryPointModalBody id={modalProps.id} />
      <CreateDepositInvoiceEntryPointModalFooter id={modalProps.id} />
    </Modal>
  )
}

export const CreateDepositInvoiceEntryPointModal = withModalConditionalRender(
  CreateDepositInvoiceEntryPointModalComponent,
)
